import { render, staticRenderFns } from "./controlPage.vue?vue&type=template&id=38639d1e&scoped=true"
import script from "./controlPage.vue?vue&type=script&lang=js"
export * from "./controlPage.vue?vue&type=script&lang=js"
import style0 from "./controlPage.vue?vue&type=style&index=0&id=38639d1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38639d1e",
  null
  
)

export default component.exports